/** Maps tRPC errors to user-facing messages. */
import {isTRPCClientError} from '@shared_ui/trpc_client';

/**
 * Resolve a thrown tRPC error to the message shown to the user. Anything that is not a
 * tRPC error, and any INTERNAL_SERVER_ERROR, resolves to the caller's fallback. A
 * BAD_REQUEST carrying the serialized zod issue list does too, since that is not prose.
 */
export function buildTrpcErrorMessage(err: unknown, fallback: string): string {
   if (!isTRPCClientError(err)) {
      return fallback;
   }

   if (err.data?.code === 'INTERNAL_SERVER_ERROR') {
      return fallback;
   }
   if (err.data?.code === 'BAD_REQUEST' && parsesAsJson(err.message)) {
      return fallback;
   }
   return err.message.length > 0 ? err.message : fallback;
}

/** True when the text is valid JSON; zod issue lists arrive as a JSON array. */
function parsesAsJson(text: string): boolean {
   try {
      JSON.parse(text);
      return true;
   } catch {
      return false;
   }
}
